import { makeStyles } from "@material-ui/core";

export const UpdateNotificationStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2, 4, 3),
  },
  labelContainer: {
    display: "flex",
    alignItems: "center",
  },
  toggleGroup: {
    marginRight: "8px",
  },
}));
